import { ObjectId } from "../../../types";
import { ActivityMeta } from "../types";

export enum CashActivityAction {
  None = 0,
  Recv,
  Spend,
  Update,
  Delete,
}

export interface CashActivityDataCommon {
  description: string;
  total_price: number;
  customer?: ObjectId;
}

export interface CashActivityRecv extends CashActivityDataCommon {
  id: ObjectId;
}

export interface CashActivitySpend extends CashActivityDataCommon {
  id: ObjectId;
}

export interface CashActivityUpdate extends CashActivityDataCommon {
  id: ObjectId;
}

export interface CashActivityDelete extends CashActivityDataCommon {}

export type CashActivityData =
  | CashActivityRecv
  | CashActivitySpend
  | CashActivityUpdate
  | CashActivityDelete;

export interface CashActivity {
  action: CashActivityAction;
  data: CashActivityData;
}

export interface CashActivityDataWithMeta extends ActivityMeta {
  activity: CashActivityData;
}
